// Predictive Search with Debugging
// Add this to your theme JavaScript file

(function() {
  console.log('Predictive Search: Script loaded');
  
  // Only target the modal search input
  const searchInput = document.querySelector('#search-modal input[name="q"]');
  const searchModal = document.querySelector('#search-modal');
  
  console.log('Search Input Found:', searchInput);
  console.log('Search Modal Found:', searchModal);
  
  if (!searchInput || !searchModal) {
    console.error('Predictive Search: Missing elements');
    return;
  }

  // Create results container
  const resultsContainer = document.createElement('div');
  resultsContainer.className = 'predictive-search-results';
  resultsContainer.style.cssText = 'width: 90%; margin: 30px auto 0; background: white; border-radius: 8px; padding: 10px;';
  
  // Insert after the search form
  const searchForm = searchModal.querySelector('.search-form');
  if (searchForm && searchForm.parentNode) {
    searchForm.parentNode.insertBefore(resultsContainer, searchForm.nextSibling);
    console.log('Results container inserted');
  } else {
    console.error('Could not find search form parent');
  }

  let debounceTimer;
  
  searchInput.addEventListener('input', function(e) {
    const query = e.target.value.trim();
    const editor = document.getElementById('search-modal');
    console.log('Input event fired. Query:', query);
    
    clearTimeout(debounceTimer);
    
    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      resultsContainer.classList.remove('active');
      editor.style.height = '25vh';
      return;
    }
    
    // Show loading state
    resultsContainer.innerHTML = '<div style="padding: 20px; text-align: center;">Searching...</div>';
    resultsContainer.classList.add('active');
    resultsContainer.style.display = 'block';
    editor.style.height = '40vh';
    
    // Debounce the search
    debounceTimer = setTimeout(() => {
      console.log('Fetching results for:', query);
      fetchPredictiveResults(query);
    }, 300);
  });
  
  function fetchPredictiveResults(query) {
    // Get the search type from settings
    const searchTypeInput = document.querySelector('#search-modal input[name="type"]');
    const searchType = searchTypeInput ? searchTypeInput.value : 'product';
    
    console.log('Search type:', searchType);
    
    // Build the URL
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=${searchType}&resources[limit]=8`;
    console.log('Fetching URL:', url);
    
    fetch(url)
      .then(response => {
        console.log('Response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('API Response:', data);
        
        // Exclude retired beauty products even while Shopify search is re-indexing.
        const retiredProductIds = new Set(['9203284639983', '9233998610671']);
        const products = (data.resources?.results?.products || []).filter(product => !retiredProductIds.has(String(product.id)));
        const articles = data.resources?.results?.articles || [];
        const pages = data.resources?.results?.pages || [];
        
        console.log('Products found:', products.length);
        console.log('Articles found:', articles.length);
        console.log('Pages found:', pages.length);
        
        displayResults(products, articles, pages, query);
      })
      .catch(error => {
        console.error('Fetch error:', error);
        resultsContainer.innerHTML = `
          <div style="padding: 20px; color: red;">
            Error: ${error.message}<br>
            Check console for details
          </div>
        `;
      });
  }
  
  function displayResults(products, articles, pages, query) {
    console.log('Displaying results');
    
    const allResults = [...products, ...articles, ...pages];
    
    if (allResults.length === 0) {
      resultsContainer.innerHTML = `
        <div style="padding: 20px; text-align: center;">
          No results found for "${escapeHtml(query)}"
        </div>
      `;
      return;
    }
    
    let html = '<div style="background: white; border-radius: 8px; padding: 10px;">';
    
    // Display products
    if (products.length > 0) {
      html += '<div style="font-weight: bold; margin-bottom: 10px;">Products:</div>';
      products.forEach(product => {
        const price = product.price ? formatMoney(product.price) : '';
        const image = product.image || '';
        
        html += `
          <a href="${product.url}" style="display: flex; padding: 10px; text-decoration: none; color: #333; border-bottom: 1px solid #eee;">
            ${image ? `<img src="${image}" style="width: 60px; height: 60px; object-fit: cover; margin-right: 10px; border-radius: 4px;">` : ''}
            <div>
              <div style="font-weight: 500;">${escapeHtml(product.title)}</div>
              <div style="color: #666;">$${product.price}</div>
            </div>
          </a>
        `;
      });
    }
    
    // Display articles
    if (articles.length > 0) {
      html += '<div style="font-weight: bold; margin: 10px 0;">Articles:</div>';
      articles.forEach(article => {
        html += `
          <a href="${article.url}" style="display: block; padding: 10px; text-decoration: none; color: #333; border-bottom: 1px solid #eee;">
            <div style="font-weight: 500;">${escapeHtml(article.title)}</div>
          </a>
        `;
      });
    }
    
    html += '</div>';
    
    resultsContainer.innerHTML = html;
    console.log('Results displayed');
  }
  
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  // Close results when clicking outside
  document.addEventListener('click', function(e) {
    if (!searchModal.contains(e.target)) {
      resultsContainer.style.display = 'none';
    }
  });
  
  // Clear results when modal closes
  const closeButton = searchModal.querySelector('[data-modal-close]');
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      resultsContainer.innerHTML = '';
      resultsContainer.style.display = 'none';
      searchInput.value = '';
    });
  }
  
  console.log('Predictive Search: Setup complete');
})();